<div class="flex flex-col gap-[12px] feature-list-item">
  <div class="label flex flex-row items-center gap-[6px]">
    <p>{{ '+INSTALLATIONS.INSTALLATION.SRC.RELATED_HEATING_CIRCUITS.LABEL' | translate }}</p>
  </div>
  <div class="flex flex-col gap-[4px]" *ngIf="heatingCircuits$ | async as heatingCircuits">
    <ng-container *ngIf="heatingCircuits.length">
      <div
        class="value flex flex-row gap-[4px] items-center"
        *ngFor="let heatingCircuit of heatingCircuits"
        (click)="openHCOverlay(heatingCircuit.circuitId)"
        gtm="onOpen"
        gtmAction="Open heating circuit overlay"
        gtmCategory="room"
      >
        <p>
          {{
            heatingCircuit.name ||
              heatingCircuit.circuitId +
                '. ' +
                ('+INSTALLATIONS.INSTALLATION.PANEL.CIRCUIT' | translate)
          }}
        </p>
        <mat-icon>chevron_right</mat-icon>
        <mat-icon
          *ngIf="heatingCircuit.showOptimizationDisabledInfo"
          [matTooltip]="
            '+INSTALLATIONS.INSTALLATION.SRC.RELATED_HEATING_CIRCUITS.OPTIMIZATION_DISABLED_INFO'
              | translate
          "
          >info_outline</mat-icon
        >
      </div>
    </ng-container>
    <ng-container *ngIf="showOptimizationInfo$ | async">
      <div class="info flex flex-row gap-[8px] items-start">
        <mat-icon>info_outline</mat-icon>
        <p>
          {{
            '+INSTALLATIONS.INSTALLATION.SRC.RELATED_HEATING_CIRCUITS.OPTIMIZATION_INFO' | translate
          }}
        </p>
      </div>
    </ng-container>
    <ng-container *ngIf="showNoSmartClimateComponentsInfo$ | async">
      <div class="info flex flex-row gap-[8px] items-start">
        <mat-icon>info_outline</mat-icon>
        <p>
          {{
            '+INSTALLATIONS.INSTALLATION.SRC.RELATED_HEATING_CIRCUITS.NO_SMART_CLIMATE_COMPONENTS_INFO'
              | translate
          }}
        </p>
      </div>
    </ng-container>
  </div>
  <div
    class="link flex flex-row gap-[8px]"
    (click)="openSrcSettingsOverlay()"
    gtm="onOpen"
    gtmAction="Open Smart Climate Optimization settings"
    gtmCategory="room"
  >
    <p>
      {{
        '+INSTALLATIONS.INSTALLATION.SRC.RELATED_HEATING_CIRCUITS.SMART_CLIMATE_OPTIMIZATION_SETTINGS'
          | translate
      }}
    </p>
    <img icon src="/assets/icons/arrow-right.svg" />
  </div>
</div>
